import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import s from './Hint.module.scss';

interface IProps {
  id: string;
  message: string;
}

const Hint: React.FC<IProps> = ({ id, message }) => (
  <OverlayTrigger
    key={id}
    placement="bottom-start"
    overlay={
      <Tooltip id={id}>
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: message || '' }} />
      </Tooltip>
    }
  >
    <div className={s.iconContainer}>i</div>
  </OverlayTrigger>
);

export default Hint;
